import {
  FOLLOW_UP_SETTING_PRIO,
  PLANNED_DEVIATION_SETTING_PRIO,
  UNPLANNED_DEVIATION_SETTING_PRIO,
} from 'api/digitalTwin/digitalTwinConstants'

/** An existing setting can move to another deviation type from the collected settings module only. */
export function canChangeDeviationType({
  isUpdate,
  isCollectedSettings,
}: {
  isUpdate: boolean
  isCollectedSettings: boolean
}): boolean {
  return !isUpdate || isCollectedSettings
}

type Translate = (key: string, options?: { defaultValue?: string }) => string

export function getDeviationTypeHelpText(priorityLevel: number, t: Translate): string {
  if (priorityLevel === UNPLANNED_DEVIATION_SETTING_PRIO.priority_level) {
    return t(
      'Unplanned settings are higher prioritized than planned settings. This means that if it exists both a planned and unplanned setting during the same time period, the unplanned setting will be chosen for the optimization.'
    )
  }

  if (priorityLevel === PLANNED_DEVIATION_SETTING_PRIO.priority_level) {
    return t(
      'Planned settings have a lower priority than unplanned settings. This means that if it exists both a planned and unplanned setting during the same time period, the unplanned setting will be chosen for the optimization.'
    )
  }

  if (priorityLevel === FOLLOW_UP_SETTING_PRIO.priority_level) {
    return t(
      'Follow-up settings have a higher priority than both planned and unplanned settings. Follow-up settings do not affect the production plan.'
    )
  }

  return ''
}
